export enum DocumentationCatEnum {
  POSITION_MANAGEMENT = 'POSITION_MANAGEMENT',
  RECRUITER_MANAGEMENT = 'RECRUITER_MANAGEMENT',
  TEAM_MANAGEMENT = 'TEAM_MANAGEMENT',
}
